// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

body{
  background-color: #282c34;
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

i.icon.hidden {
  display: none;
}

#playButton {
  position: absolute;
  z-index: 1;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transform: scale(5, 5);
}

.fullscreen {
  height: 100%;
}

video {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.logobacking {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-content: center;
  align-items: center;
  background-color: rgb(250, 250, 250);
  border-radius: 50% 50%;
  width: 160px;
  height: 160px;
}

.play {
  order: 0;
  flex: 1 1 auto;
  align-self: auto;
  margin: 5px;
  width: 64px;
  height: 64px;
  fill: black;
}

.stopped {
  order: 0;
  flex: 1 1 auto;
  align-self: auto;
  margin: 5px;
  width: 44px;
  height: 44px;
  fill: #9e9e9e;
}

.hidden {
  display: none !important;
}

.black-background {
  position: relative;
  background-color: black;
  color: black;
  overflow: hidden;
  zoom: 1;
}



@media (max-width: 480px) {
  html {
      font-size: 12px;
  }
}

@media (min-width: 480px) {
  html {
      font-size: 100px;
  }
}

@media (min-width: 768px) {
  html {
      font-size: 100px;
  }
}

@media (min-width: 992px) {
  html {
      font-size: 100px;
  }
}

@media (min-width: 1200px) {
  html {
      font-size: 100px;
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,qBAAqB;EACrB,mBAAmB;EACnB,oCAAoC;EACpC,sBAAsB;EACtB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,QAAQ;EACR,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,QAAQ;EACR,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,OAAO;AACT;;;;AAIA;EACE;MACI,eAAe;EACnB;AACF;;AAEA;EACE;MACI,gBAAgB;EACpB;AACF;;AAEA;EACE;MACI,gBAAgB;EACpB;AACF;;AAEA;EACE;MACI,gBAAgB;EACpB;AACF;;AAEA;EACE;MACI,gBAAgB;EACpB;AACF","sourcesContent":[".App {\r\n  text-align: center;\r\n}\r\n\r\n.App-logo {\r\n  height: 40vmin;\r\n  pointer-events: none;\r\n}\r\n\r\n@media (prefers-reduced-motion: no-preference) {\r\n  .App-logo {\r\n    animation: App-logo-spin infinite 20s linear;\r\n  }\r\n}\r\n\r\nbody{\r\n  background-color: #282c34;\r\n}\r\n\r\n.App-header {\r\n  background-color: #282c34;\r\n  min-height: 100vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: calc(10px + 2vmin);\r\n  color: white;\r\n}\r\n\r\n.App-link {\r\n  color: #61dafb;\r\n}\r\n\r\n@keyframes App-logo-spin {\r\n  from {\r\n    transform: rotate(0deg);\r\n  }\r\n\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\ni.icon.hidden {\r\n  display: none;\r\n}\r\n\r\n#playButton {\r\n  position: absolute;\r\n  z-index: 1;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  transform: scale(5, 5);\r\n}\r\n\r\n.fullscreen {\r\n  height: 100%;\r\n}\r\n\r\nvideo {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: contain;\r\n}\r\n\r\n.logobacking {\r\n  display: flex;\r\n  flex-direction: row;\r\n  flex-wrap: wrap;\r\n  justify-content: center;\r\n  align-content: center;\r\n  align-items: center;\r\n  background-color: rgb(250, 250, 250);\r\n  border-radius: 50% 50%;\r\n  width: 160px;\r\n  height: 160px;\r\n}\r\n\r\n.play {\r\n  order: 0;\r\n  flex: 1 1 auto;\r\n  align-self: auto;\r\n  margin: 5px;\r\n  width: 64px;\r\n  height: 64px;\r\n  fill: black;\r\n}\r\n\r\n.stopped {\r\n  order: 0;\r\n  flex: 1 1 auto;\r\n  align-self: auto;\r\n  margin: 5px;\r\n  width: 44px;\r\n  height: 44px;\r\n  fill: #9e9e9e;\r\n}\r\n\r\n.hidden {\r\n  display: none !important;\r\n}\r\n\r\n.black-background {\r\n  position: relative;\r\n  background-color: black;\r\n  color: black;\r\n  overflow: hidden;\r\n  zoom: 1;\r\n}\r\n\r\n\r\n\r\n@media (max-width: 480px) {\r\n  html {\r\n      font-size: 12px;\r\n  }\r\n}\r\n\r\n@media (min-width: 480px) {\r\n  html {\r\n      font-size: 100px;\r\n  }\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  html {\r\n      font-size: 100px;\r\n  }\r\n}\r\n\r\n@media (min-width: 992px) {\r\n  html {\r\n      font-size: 100px;\r\n  }\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n  html {\r\n      font-size: 100px;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
